<template>
  <el-card shadow="never" v-loading="loading">
    <template #header>
      <CardTitle title="会员终端" />
    </template>
    <Echart :height="300" :options="terminalChartOptions" />
  </el-card>
</template>
<script lang="ts" setup>
import * as MemberStatisticsApi from '@/api/mall/statistics/member'
import { EChartsOption } from 'echarts'
import { MemberTerminalStatisticsRespVO } from '@/api/mall/statistics/member'
import { DICT_TYPE, DictDataType, getIntDictOptions } from '@/utils/dict'
import { CardTitle } from '@/components/Card'

/** 会员终端卡片 */
defineOptions({ name: 'MemberTerminalCard' })

const loading = ref(true) // 加载中

/** 会员终端统计图配置 */
const terminalChartOptions = reactive<EChartsOption>({
  tooltip: {
    trigger: 'item',
    confine: true,
    formatter: '{b} : {c} 人 ({d}%)'
  },
  color: ['#3b82f6', '#22c55e', '#f97316', '#a855f7', '#14b8a6', '#ef4444'],
  legend: {
    orient: 'horizontal',
    bottom: 0,
    icon: 'circle',
    itemWidth: 8,
    itemHeight: 8,
    itemGap: 14,
    textStyle: { color: '#666', fontSize: 12 }
  },
  series: [
    {
      name: '会员终端',
      type: 'pie',
      radius: ['42%', '64%'],
      center: ['50%', '42%'],
      itemStyle: { borderColor: '#fff', borderWidth: 2, borderRadius: 4 },
      label: {
        show: true,
        formatter: '{b}\n{d}%',
        color: '#666',
        fontSize: 12
      },
      labelLine: {
        show: true,
        length: 10,
        length2: 10,
        lineStyle: { color: '#c0c4cc' }
      },
      data: []
    }
  ]
}) as EChartsOption

/** 按照终端，查询会员统计列表 */
const getMemberTerminalStatisticsList = async () => {
  loading.value = true
  const list = await MemberStatisticsApi.getMemberTerminalStatisticsList()
  const dictDataList = getIntDictOptions(DICT_TYPE.TERMINAL)
  terminalChartOptions.series![0].data = dictDataList.map((dictData: DictDataType) => {
    const userCount = list.find(
      (item: MemberTerminalStatisticsRespVO) => item.terminal === dictData.value
    )?.userCount
    return {
      name: dictData.label,
      value: userCount || 0
    }
  })
  loading.value = false
}

/** 初始化 **/
onMounted(() => {
  getMemberTerminalStatisticsList()
})
</script>
